import { useTheme } from "../themes/ThemeContext";

function ClassicHeader({ appId,venueName,venueLogo,bannerImage,showLogo,merchantURL }) {

	const handleReturnToVenueClick = (e) => {
		e.preventDefault();
		window.open(merchantURL, '_self')
	};

	// Constants
	const venueNameDisplay = showLogo ? <figure id={" + axify__widget-" + appId + "-logo"}className="axify__widget-logo"><img src={venueLogo} alt={venueName} width="400" height="400" fetchpriority="high" /></figure> : <span className="venueName">{venueName}</span>;

	return(
		<header id={ "axify__widget-" + appId + "-header" } className="axify__widget-header layout-classic">
			<button id={ "axify__widget-" + appId + "-backToVenue" } className="axify__widget-ui-button small exit" onClick={handleReturnToVenueClick}><span className="label">Back to Venue</span></button>

			{venueNameDisplay}
			{/* <figure id={ "axify__widget-" + appId + "-logo" } className='axify__widget-logo'><img src={venueLogo} alt={venueName} width="400" height="400" fetchpriority="high" /> </figure> */}

			<figure id={ "axify__widget-" + appId + "-banner" } className="axify__widget-banner">
				<img src={'data:image/png;base64, ' + bannerImage} alt={venueName} width="1920" height="507" fetchpriority="high" />
			</figure>
		</header>
	);
}

function CompactHeader({ appId, venueName, merchantURL, agentDisplayName, onClose }) {
	const handleClose = (e) => {
		e.preventDefault();
		if (typeof onClose === "function") {
			onClose();
			return;
		}
		if (merchantURL) {
			window.open(merchantURL, "_self");
		}
	};

	const displayName = agentDisplayName || venueName || "Concierge";

	return (
		<header
			id={"axify__widget-" + appId + "-header"}
			className="axify__widget-header layout-compact"
		>
			<div className="axify__widget-header-status" aria-hidden="true">
				<span className="axify__widget-header-dot" />
				<span className="axify__widget-header-status-label">Online</span>
			</div>

			<h1 className="axify__widget-header-title">{displayName}</h1>

			<button
				type="button"
				id={"axify__widget-" + appId + "-close"}
				className="axify__widget-header-close"
				onClick={handleClose}
				aria-label="Close concierge"
			>
				<svg
					width="20"
					height="20"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
					aria-hidden="true"
				>
					<line x1="18" y1="6" x2="6" y2="18" />
					<line x1="6" y1="6" x2="18" y2="18" />
				</svg>
			</button>
		</header>
	);
}

function Header(props) {
	const theme = useTheme();
	const layout = theme?.layout || "classic";
	return layout === "compact" ? <CompactHeader {...props} /> : <ClassicHeader {...props} />;
}

export default Header;
